import { Card } from '@ui';
import dynamic from 'next/dynamic';
import { Controller } from 'react-hook-form';
import { useInputError } from './hooks';
import { FormInputProps } from './props';

const AceEditorNoSSR = dynamic(
    async () => {
        const Ace = await import('react-ace');

        await import('ace-builds/src-noconflict/mode-html');
        await import('ace-builds/src-noconflict/theme-github');
        await import('ace-builds/src-noconflict/ext-language_tools');

        return Ace;
    },
    {
        ssr: false
    }
);

interface Props extends FormInputProps {}

export const FormCodeEditor = ({ name, label }: Props) => {
    const errorMessageComponent = useInputError(name, true);
    const isInvalid = errorMessageComponent !== null;

    return (
        <Controller
            name={name}
            render={({ field: { onChange, value }, formState: { isValid } }) => (
                <div className="tw-mb-8">
                    {label && (
                        <label
                            className={`tw-rounded-sm tw-p-0 tw-pb-2 tw-text-[14px] ${isInvalid && 'tw-text-error'}`}
                        >
                            {label}
                        </label>
                    )}
                    <Card
                        className={`tw-rounded-sm tw-p-0 ${isInvalid ? 'tw-border tw-border-red-500' : 'tw-border tw-border-neutral-300'}`}
                    >
                        <AceEditorNoSSR
                            mode="html"
                            theme="github"
                            name="UNIQUE_ID_OF_DIV"
                            height="300px"
                            width="auto"
                            setOptions={{ useWorker: false }}
                            editorProps={{ $blockScrolling: true }}
                            onChange={onChange}
                            value={value}
                        />
                    </Card>
                    {errorMessageComponent}
                </div>
            )}
        />
    );
};
